import script from "./FeatureModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureModal.vue?vue&type=script&setup=true&lang=js"

import "./FeatureModal.vue?vue&type=style&index=0&id=1281c047&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1281c047"]])

export default __exports__